import { Stack, VStack } from '@genial/components';
import { Box, HStack } from 'native-base';
import React from 'react';

import { RecommendedPortfolioBadge } from '../../../../../../../components/RecommendedPortfolioBadge';
import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { StrategyAssetsQueryItem } from '../../../../../../../store/customerAssetDetail/types';
import { IDynamicProductSearchItem } from '../../../_dynamic';
import { tableHead } from '../../constants';
import { ProfitabilityText } from '../ProfitabilityText';

export const ProductItemDesktop: React.FC<IDynamicProductSearchItem<StrategyAssetsQueryItem>> = ({
  item,
}) => {
  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} py="stack.xxs" px="inline.xxxs">
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        w="4px"
        backgroundColor={item.productColor}
        borderTopLeftRadius="full"
        borderBottomLeftRadius="full"
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <HStack
          justifyContent="space-between"
          alignItems="center"
          space="inline.nano"
          mr="inline.nano">
          <VStack space="stack.nano">
            <TableContentItemText>{item.assetNameNormalized}</TableContentItemText>
            <TableContentItemText color="neutral.medium">
              {item.typeNameNormalized}
            </TableContentItemText>
          </VStack>
          <Stack pr="inline.lg">
            <RecommendedPortfolioBadge
              hasRecommendedPortfolioLink={item.hasRecommendedPortfolioLink}
              recommendedPortfolioLinks={item.recommendedPortfolioLinks}
            />
          </Stack>
        </HStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.grossValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.netValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.quantity}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <ProfitabilityText profitability={item.profitability} />
      </TableContentItemColumn>
    </TableContent>
  );
};
